import React from 'react';
import './OrdersTabs.scss';
import clsx from 'clsx';
import trans from 'translate';
import PropTypes from 'prop-types';
import Tabs from '../../../../../Common/Tabs/Tabs';
import OpenOrders from './OpenOrders/OpenOrders';
import NewOrder from './NewOrder/NewOrder';

const _tabs = [
  {
    title: 'hpool.new_order',
    id: 'newOrder',
  },
  {
    title: 'hpool.open_order',
    id: 'openOrders',
  },
  {
    title: 'hpool.finished_order',
    id: 'finishedOrders',
  },
];

const TabPicker = ({ tabs = [], setCurrentTab, currentTab }) => (
  <div className="order-tabs">
    {tabs.map((tab) => (
      <React.Fragment key={tab.id}>
        <div
          onClick={() => setCurrentTab(tab.id)}
          className={clsx('order-tab', { 'tab-active': currentTab === tab.id })}
        >
          {currentTab === tab.id && <div className="active-indicator" />}
          <span>{trans(tab.title)}</span>
        </div>
      </React.Fragment>
    ))}
  </div>
);

TabPicker.defaultProps = {
  setCurrentTab: null,
  currentTab: null,
};

TabPicker.propTypes = {
  tabs: PropTypes.array.isRequired,
  setCurrentTab: PropTypes.func,
  currentTab: PropTypes.string,
};

export default function OrdersTabs() {
  return (
    <div className="order-tabs-wrapper">
      <Tabs initCurrentTab={_tabs[0].id} tabs={_tabs} TabPicker={TabPicker}>
        <Tabs.Tab tab="newOrder">
          <NewOrder />
        </Tabs.Tab>
        <Tabs.Tab tab="openOrders">
          <OpenOrders />
        </Tabs.Tab>
        <Tabs.Tab tab="finishedOrders">
          <OpenOrders ordersState="executed" tableProps={{ hiddenCols: ['cancel'] }} />
        </Tabs.Tab>
      </Tabs>
    </div>
  );
}
